import React from 'react';

import { BaseLabel, RowContainer, InputSmall } from '../../../../styles/styleUtils';

function NumeroIdentificador({ formData, onInputChange }) {
  return (
    <div>
      <RowContainer>
        <BaseLabel htmlFor="numeroIndentificador">Número Identificador</BaseLabel>
        <InputSmall
          type="text"
          id="numeroIndentificador"
          name="numeroIndentificador"
          value={formData.numeroIndentificador}
          onChange={onInputChange}
        />
      </RowContainer>
    </div>
  );
}

export default NumeroIdentificador;
